const selectCourseCohorts = state => state.cohorts.cohorts;

export default selectCourseCohorts;
